/**
 * Created by Jonas Wålekvist on 2018-10-12.
 */
import {EnvironmentContainer} from "./EnvironmentContainer";
import {TimelineLite, TweenLite} from "gsap";
import {DirtyWildColorConfig} from "../../../config/DirtyWildColorConfig";
import {DirtyWildGameMode} from "../../features/DirtyWildsRespinZeroBetController";


export class EnvironmentTintContainer extends EnvironmentContainer {
    private _currentColor:string;
    private _currentAmount:number;
    private _currentSaturation:number;
    private _currentBrightness:number;


    constructor(parent:PIXI.Container | null = null) {
        super(parent);
        this.getTransitionToNormal(0);
        this.getHideColorAnimation(0);
    }

    public getTransitionToNormal(duration:number):TimelineLite {
        return this.getLocalColorize(duration, DirtyWildColorConfig.getNoWinSymbolModeColor(DirtyWildGameMode.NORMAL), 0.08, 1, 0.5);
    }

    public getTransitionToRespin(duration:number):TimelineLite {
        return this.getLocalColorize(duration, DirtyWildColorConfig.getNoWinSymbolModeColor(DirtyWildGameMode.STICKY_RESPIN), 0.08, 1, 0.5);
    }

    private getLocalColorize(duration:number, color:string, amount:number, saturation:number, brightness:number):TimelineLite {
        this._currentColor = color;
        this._currentAmount = amount;
        this._currentSaturation = saturation;
        this._currentBrightness = brightness;

        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this, duration, {
            pixi : {
                colorize : color,
                colorizeAmount : amount,
                saturation : saturation,
                brightness : brightness
            }
        }), 0);
        return tl;
    }

    public getHideColorAnimation(duration:number) {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this, duration, {
            pixi : {
                colorize : this._currentColor,
                colorizeAmount : 0,
                saturation : 1,
                brightness : 1
            }
        }));
        return tl;
    }

    public getShowColorAnimation(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this, duration, {
            pixi : {
                colorize : this._currentColor,
                colorizeAmount : this._currentAmount,
                saturation : this._currentSaturation,
                brightness : this._currentBrightness
            }
        }));
        return tl;
    }
}